export const isBrowserRuntime = () => typeof window !== 'undefined' && typeof document !== 'undefined';

const getRuntimeInfo = (): string => {
  const runtimeGlobal = globalThis as typeof globalThis & {
    Bun?: {
      version?: string;
    };
    Deno?: {
      version?: {
        deno?: string;
      };
    };
    process?: {
      versions?: {
        bun?: string;
        node?: string;
      };
    };
  };
  const bunVersion = runtimeGlobal.Bun?.version ?? runtimeGlobal.process?.versions?.bun;

  if (bunVersion) return `bun/${bunVersion}`;

  const denoVersion = runtimeGlobal.Deno?.version?.deno;

  if (denoVersion) return `deno/${denoVersion}`;

  const nodeVersion = runtimeGlobal.process?.versions?.node;

  if (nodeVersion) return `node/${nodeVersion}`;

  return '';
};

export const getUserAgent = (applicationKey: string) => {
  const runtimeInfo = getRuntimeInfo();

  return `ev/${applicationKey} ${runtimeInfo}`.trim();
};
